<template lang="pug">
v-navigation-drawer(
  bottom,
  color='white',
  fixed,
  height='auto',
  scrim='rgba(10, 10, 10, 0.68)',
  temporary,
  class='home-drawer',
  v-bind='$attrs',
)
  v-list(color='white')
    v-list-item(
      v-for='(name, i) in items',
      :key='i',
      :to='name.slug',
      color='primary'
    )
      
      v-list-item-title(v-text='name.title')
    v-list-item
      LanguageSwitcher
</template>

<script setup>
defineOptions({
  name: 'HomeDrawer',
})

const props = defineProps({
  items: {
    type: Array,
    default: () => [],
  },
})
</script>

<style scoped>
.home-drawer {
  background: var(--surface-card) !important;
  border-top: 1px solid var(--border-default);
}

.home-drawer :deep(.v-navigation-drawer__content) {
  background: var(--surface-card);
}
</style>
